import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./step2Travel.css";
import "./step4Travel.css";

const initialDocuments = [
  { id: 1, title: "Event Invitation / Agenda", file: "Event_Invitation_Simpleview_Summit_2023.pdf", size: "420KB" },
  { id: 2, title: "Travel Itinerary", file: "Travel_Itinerary_Draft.pdf", size: "420KB" },
  { id: 3, title: "Hotel Quotation", file: "", size: "" },
  { id: 4, title: "Purpose Document / Justification", file: "", size: "" },
  { id: 5, title: "Passport / Visa Copy", file: "", size: "" },
];

const Stepper = () => (
  <div className="s2-stepper">
    {["Traveler & Budget", "Schedule", "Cash Advance", "Documents", "Review & Submit"].map((label, index) => (
      <React.Fragment key={label}>
        <div className={`s2-step ${index < 3 ? "done" : index === 3 ? "active" : ""}`}>
          <span>{index < 3 ? <i className="ri-check-line" /> : index + 1}</span>
          <div><strong>{label}</strong><small>{index < 3 ? "Completed" : index === 3 ? "In progress" : "Pending"}</small></div>
        </div>
        {index < 4 && <i className={`s2-step-line ${index < 3 ? "done" : ""}`} />}
      </React.Fragment>
    ))}
  </div>
);

const DocumentRow = ({ document, onUpload, onRemove }) => {
  const inputRef = useRef(null);
  return <div className={`s4-document ${document.file ? "uploaded" : "pending"}`}>
    <div className="s4-document-info">
      <i className={document.file ? "ri-checkbox-fill" : "ri-checkbox-blank-line"} />
      <div><strong>{document.title}</strong><small>{document.file ? `${document.file} · ${document.size}` : "Required — click upload to attach"}</small></div>
    </div>
    {document.file ? <button type="button" className="s4-remove" onClick={onRemove} aria-label={`Remove ${document.title}`}><i className="ri-close-line" /></button> : <>
      <input ref={inputRef} type="file" accept=".pdf,.jpg,.jpeg,.png" hidden onChange={(event) => event.target.files[0] && onUpload(event.target.files[0])} />
      <button type="button" className="s4-upload" onClick={() => inputRef.current?.click()}><i className="ri-upload-2-line" /> Upload</button>
    </>}
  </div>;
};

const TravelRequestCreateStep4 = () => {
  const [documents, setDocuments] = useState(initialDocuments);
  const updateFile = (id, file) => setDocuments((items) => items.map((item) => item.id === id ? { ...item, file: file.name, size: `${Math.max(1, Math.round(file.size / 1024))}KB` } : item));
  const removeFile = (id) => setDocuments((items) => items.map((item) => item.id === id ? { ...item, file: "", size: "" } : item));

  return <div className="s2-page s4-page">
    <div className="s2-heading"><div><h1>Create Travel Request</h1><p>Step 4 of 5 · Documents</p></div><Stepper /></div>
    <div className="s2-layout">
      <main className="s4-main">
        <section className="s2-card">
          <header className="s2-title s4-title"><div><span>1</span><h2>Required Documents</h2></div><small>Must be uploaded before submission</small></header>
          <div className="s4-documents">
            {documents.map((document) => <DocumentRow key={document.id} document={document} onUpload={(file) => updateFile(document.id, file)} onRemove={() => removeFile(document.id)} />)}
          </div>
        </section>
        <div className="s4-info"><i className="ri-information-fill" /><div><strong>Booking documents come later</strong><p>Flight and hotel booking confirmations and travel insurance are arranged and uploaded by Admin after this request is approved. They will appear in your request details once ready — nothing to upload here.</p></div></div>
      </main>
      <aside className="s2-aside">
        <section><h3><i className="ri-refresh-line" /> What Happens Next</h3><p>After you submit:</p><ol><li>Your manager receives an approval request.</li><li>Once approved, Admin arranges flights, hotel and insurance.</li><li>Admin uploads booking confirmations.</li><li>Finance processes the cash advance payment.</li></ol></section>
      </aside>
    </div>
    <footer className="s2-actions"><Link to="/travel/create/step-3">Back</Link><span>Step 4 of 5 · Documents</span><div><button type="button">Save as Draft</button><Link className="primary" to="/travel/create/step-5">Continue</Link></div></footer>
  </div>;
};

export default TravelRequestCreateStep4;
